module.exports = __webpack_public_path__ + "static/media/dry_fruits.6ae3913c.png";